<template>
  <footer class="footer-dep" role="contentinfo">
    <div class="container-fluid dep-contact" itemscope itemtype="http://schema.org/Organization">
      <div class="container">
        <div class="logo-anjou" itemprop="logo">   
        <!--<a href="https://www.maine-et-loire.fr" target="_blank" title="Département de Maine-et-Loire - Anjou : aller à la page d'accueil du site maine-et-loire.fr (Nouvelle fenêtre)">-->
          <span class="dep49-icon-logo-anjou icon-logo-anjou-footer" aria-hidden="true" data-glyph="icon-logo-anjou" title="Département de Maine-et-Loire - Anjou"></span>
        <!--</a>-->
        </div>
        <address itemprop="contactPoints">
          <p>
            <strong itemprop="name">Département de Maine-et-Loire</strong><br />
            <span itemprop="address">
              CS 94104<br />
              49941 Angers Cedex 9
            </span>
          </p>

          <p class="dep-telephone">
            <a href="https://www.maine-et-loire.fr" itemprop="url">maine-et-loire.fr</a>
            <span itemprop="telephone"><a href="tel:+0241814949" title="Appeler le Département par téléphone au 02 41 81 49 49">02 41 81 49 49</a></span></p>
          </address>

          <a href="https://www.maine-et-loire.fr/contacter-le-departement/" class="btn" target="_blank" title="Département de Maine-et-Loire - Anjou : aller au formulaire de contact du site maine-et-loire.fr (Nouvelle fenêtre)">Contactez le Département</a>
        </div>
      </div>

    </footer>
</template>

<script>
export default {
  name: 'footer-dep'
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Footer.vue?6fde76fa